<div class="footer">
  <div class="container" [ngClass]="{ ar: translate.currentLang === 'ar' }">
    <div class="row">
      <div class="col-12 col-md-5 col-lg-5">
        <ul>
          <li>
            <mat-icon> location_on</mat-icon>
            <span>{{ "contact.address" | translate }}</span>
          </li>
          <li>
            <mat-icon>mail</mat-icon>
            <p>{{ "WeCare@AbouSamraTravel.com" }}</p>
          </li>
          <li>
            <mat-icon> local_phone</mat-icon>
            <p class="phoneNum">0227730393-99, 00201022251135</p>
          </li>
          <li>
            <mat-icon> local_phone</mat-icon>
            <p class="phoneNum">00201022248838, 00201021042488</p>
          </li>
        </ul>
      </div>
      <div class="col-12 col-md-7 col-lg-7">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6">
            <ul>
              <li class="title">
                <a href=""> {{ "footer.company" | translate }}</a>
              </li>
              <li>
                <a (click)="goToAboutUs()">
                  {{ "footer.about" | translate }}
                </a>
              </li>
              <li>
                <a (click)="goToContactUs()">
                  {{ "footer.contact" | translate }}
                </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-6 col-lg-6">
            <ul>
              <li class="title">
                {{ "footer.more" | translate }}
              </li>
              <li>
                <a (click)="goToPrivacy()">
                  {{ "footer.PrivacyPolicy" | translate }}
                </a>
              </li>
              <li>
                <a (click)="goToTermsOfUse()">
                  {{ "footer.TermofUse" | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="Payment" [ngClass]="{ ar: translate.currentLang === 'ar' }">
        <img src="../../../../assets/icons/footer/visa.svg" alt="" srcset="" />
        <img
          src="../../../../assets/icons/footer/master.svg"
          alt=""
          srcset=""
        />
        <!-- <img src="../../../../assets/images/footer/knet.svg" alt="" srcset=""> -->

        <!-- <img src="../../../../assets/images/footer/amadeus.svg" alt="" srcset=""> -->
      </div>
    </div>
  </div>
</div>
